export default __webpack_public_path__ + "static/media/mybox.06b714a7.ico";